export default __webpack_public_path__ + "static/media/iconBox.76936646.svg";